

//const linearRegression = (x1 : number, y1: number, x2: number, y2: number, x: number) => (y2 - y1) / (x2 - x1) * (x - x1) + y1;


export function sampleData(datatype : boolean,  randomArray:number[], totalValues : number) : number[]{

    const firstValue = randomArray[0];
    const lastValue = randomArray[randomArray.length - 1];
    const interval = (randomArray[randomArray.length - 1] - randomArray[0]) / (randomArray.length - 1);
    // 100개의 배열 생성
    const expandedArray = Array.from({ length: totalValues }, (_, index) => {
        const ratio = index / (totalValues - 1);
        const nearestIndex = Math.floor(ratio * (randomArray.length - 1));
        const interpolatedValue = randomArray[nearestIndex] + interval * (ratio * (randomArray.length - 1) - nearestIndex);
        if(datatype)
          return Math.round(interpolatedValue);
        else
          return interpolatedValue;
      });

      return expandedArray;
}

export function downsampleValues(values: number[], targetCount: number): number[] {
  if (targetCount >= values.length) {
    return values;
  }

  const step = values.length / targetCount;
  const downsampledValues: number[] = [];

  for (let i = 0; i < targetCount; i++) {
    const index = Math.floor(i * step);
    downsampledValues.push(values[index]);
  }

  downsampledValues[0] = values[0];
  downsampledValues[downsampledValues.length - 1] = values[values.length - 1];

  return downsampledValues;
}


export function convert2Array(data : number[]):number[][]{
  const exceldata : number[][]  = [];

  for(let i = 0; i < data.length; ++i){

    exceldata.push([i, data[i]]);
  }  

  return exceldata;
}

